'use client';

import { useGetHeroByType } from '@/lib/react-query/HeroQueries';
import { cn } from '@/lib/utils';
import type { HeroImage } from '@/types/content.types';

type Props = {
  className?: string;
  type: 'piercing' | 'tattoo';
  images?: Array<HeroImage>;
};

const HeroImages = ({ className = '', type, images: imagesProp }: Props) => {
  const { data: hero } = useGetHeroByType(type);

  const images = imagesProp ?? hero?.images?.slice(0, 5) ?? [];

  const image0 = images[0]?.image_url;
  const image1 = images[1]?.image_url;
  const image2 = images[2]?.image_url;
  const image3 = images[3]?.image_url;
  const image4 = images[4]?.image_url;

  return (
    <div
      className={cn(
        'mt-14 flex justify-end gap-8 sm:-mt-20 sm:justify-start sm:pl-20 lg:mt-0 lg:pl-0',
        className,
      )}
    >
      <div className="ml-auto w-44 flex-none space-y-8 pt-32 sm:ml-0 sm:pt-80 lg:order-last lg:pt-36 xl:order-none xl:pt-80">
        <div className="relative">
          <img
            src={image0 || ''}
            alt={image0 || ''}
            className="aspect-2/3 w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
            height={264}
            width={176}
            fetchPriority="high"
          />
          <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-gray-900/10 ring-inset" />
        </div>
      </div>
      <div className="mr-auto w-44 flex-none space-y-8 sm:mr-0 sm:pt-52 lg:pt-36">
        <div className="relative">
          <img
            src={image1 || ''}
            alt={image1 || ''}
            className="aspect-2/3 w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
            height={264}
            width={176}
            loading="lazy"
          />
          <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-gray-900/10 ring-inset" />
        </div>
        <div className="relative">
          <img
            src={image2 || ''}
            alt={image2 || ''}
            className="aspect-2/3 w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
            height={264}
            width={176}
            loading="lazy"
          />
          <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-gray-900/10 ring-inset" />
        </div>
      </div>
      <div className="w-44 flex-none space-y-8 pt-32 sm:pt-0">
        <div className="relative">
          <img
            src={image3 || ''}
            alt={image3 || ''}
            className="aspect-2/3 w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
            height={264}
            width={176}
            loading="lazy"
          />
          <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-gray-900/10 ring-inset" />
        </div>
        <div className="relative">
          <img
            src={image4 || ''}
            alt={image4 || ''}
            className="aspect-2/3 w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
            height={264}
            width={176}
            loading="lazy"
          />
          <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-gray-900/10 ring-inset" />
        </div>
      </div>
    </div>
  );
};

export default HeroImages;
